<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (customerBaseData) {
  <div class="mt-3">
    @if (dialogMode === 'initial') {
      <web-design-system-button size="small" [disabled]="isJointFsaDisabled" (click)="dialogMode = 'edit'">
        {{
          customerBaseData.fsaAmount > 0
            ? ('user-self-service.tax.switch-change-fsa.btn-title-edit' | transloco)
            : ('user-self-service.tax.switch-change-fsa.btn-title-add' | transloco)
        }}
      </web-design-system-button>
    }
    @if (dialogMode === 'openChange') {
      <web-design-system-button size="small" [disabled]="true">
        {{ 'user-self-service.tax.switch-change-fsa.btn-open-change' | transloco }}
      </web-design-system-button>
    }
    @if (dialogMode === 'edit' || dialogMode === 'verify') {
      <h5>
        {{
          customerBaseData.fsaAmount > 0
            ? ('user-self-service.tax.switch-change-fsa.title-edit' | transloco)
            : ('user-self-service.tax.switch-change-fsa.title-add' | transloco)
        }}
      </h5>
      @if (showJointFsa) {
        <div class="mt-3">
          <web-design-system-switch
            [label]="'user-self-service.tax.switch-change-fsa.label-joint-fsa-toggle' | transloco"
            [checked]="showJointFsa"
            (checkedChange)="toggleFsaType()"
          />
        </div>
      }
      <div class="mt-3">
        @if (showJointFsa) {
          <self-service-change-joint-fsa [customerBaseData]="customerBaseData" [dialogMode]="dialogMode" />
        } @else {
          <self-service-change-fsa
            [existingFsaAmount]="customerBaseData.fsaAmount"
            [existingFsaUsedAmount]="customerBaseData.fsaUsed"
            [customerId]="customerBaseData.customerId"
            [maritalStatus]="customerBaseData.maritalStatus"
            [dialogMode]="dialogMode"
          />
        }
      </div>
    }
  </div>

  @if (!hasTin) {
    <div class="row">
      <div class="col-12 px-0 mt-2">
        <div class="alert alert-primary" role="alert">
          @if (depotOpenedInDays < maxDepotOpenedInDays) {
            {{ 'user-self-service.tax.switch-change-fsa.joint-fsa-disabled-too-new-warning-text' | transloco }}
          } @else {
            <p [innerHTML]="'user-self-service.tax.switch-change-fsa.joint-fsa-disabled-make-ticket-warning-text' | transloco"></p>
          }
        </div>
      </div>
    </div>
  } @else if (showJointFsa) {
    <div class="row">
      <div class="col-12 mt-2">
        <div class="alert alert-primary" role="alert">
          {{ 'user-self-service.tax.switch-change-fsa.fsa-warning-text' | transloco }}
        </div>
      </div>
    </div>
  }

  <web-components-user-messages />
}
